<template>
  <dd-validation-rules-wrapper :name="name" :rules="rules">
    <template #default="validationWrapperProps">
      <div class="flex-col gap-y-xs">
        <validation-provider
            :name="name"
            ref="provider"
            :rules="validationWrapperProps.rules"
            v-slot="validationProps"
        >
          <input type="hidden" v-model="radioGroupModel">
          <dd-input-wrapper
            :rules="validationWrapperProps.rules"
            :title="title"
            :errors="validationProps.errors"
            :name="name"
            :value="value"
          />
        </validation-provider>
        <div :data-dusk="dataDusk" class="flex-col gap-y-md" ref="self">
          <slot></slot>
        </div>
      </div>
    </template>
  </dd-validation-rules-wrapper>
</template>

<script>
export default {
  name: "DdRadioGroup",
  emits: ['input', 'click'],
  props: {
    dataDusk: String,
    title: {
      type: String,
      required: false
    },
    groupName: {
      type: String,
      required: false,
      default: () => Math.floor(Math.random() * 1000000000).toString(),
    },
    name: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      required: false,
      default: null,
    },
    rules: {
      type: [String, Array, Object],
      required: false,
    },
  },
  provide(){
    return {
      groupName: this.groupName,
    };
  },
  watch: {
    value() {
      this.radioGroupModel = this.value;
      this.updateDomInputValueWithProp();
    }
  },
  methods: {
    onRadioButtonClick(radioWrapper) {
      let value = radioWrapper.getElementsByClassName('radio-input')[0].value;
      this.radioGroupModel = value;
      this.$emit('input', value);
      this.$emit('click', value);
    },
    initializeRadioListeners() {
      this.radioButtons = this.$refs.self.getElementsByClassName('radio-input-wrapper');
      for(let radio of this.radioButtons) {
          radio.removeEventListener('click', () => this.onRadioButtonClick(radio));
          radio.addEventListener('click', () => this.onRadioButtonClick(radio))
      }
      if (this.value !== undefined && this.value !== null) {
        this.updateDomInputValueWithProp();
      }
    },
    updateDomInputValueWithProp() {
      this.radioInputs = this.$refs.self.getElementsByClassName('radio-input');
      for(let radioInput of this.radioInputs) {
        // TODO: convert value prop to string internally and parse as int when emitting value. Same as in dd-select.
        if (radioInput.hasAttribute('value')) {
        // eslint-disable-next-line > GEEN strict comparison zodat values als '0' ook worden gematched met 0;
          radioInput.checked = (radioInput.getAttribute('value') == this.value)
        }
      }
    }
  },
  beforeUnmount() {
    for(let radio of this.radioButtons) {
      radio.removeEventListener('click', () =>  this.onRadioButtonClick(radio));
    }
  },
  mounted() {
    this.initializeRadioListeners();
    const observer = new MutationObserver(() => this.initializeRadioListeners());
    observer.observe(this.$refs.self, {
      childList: true,
      subtree: true,
    });
  },
  data() {
    return {
      radioButtons: null,
      radioGroupModel: this.value,
    }
  }
}
</script>
